import {Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {DataService} from 'shared/_services/data.service';
import {AuthService} from 'app/auth/auth.service';
import * as fromMessaging from 'projects/messaging/src/messaging.actions';
import {Store} from '@ngrx/store';

@Component({
	selector: 'shared-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class FileUploadComponent {

	@ViewChild('myPond', {static: true}) myPond: any;

	@Output() done = new EventEmitter();
	@Output() loading = new EventEmitter();
	@Output() remove = new EventEmitter();
	@Output() fileLoadingError = new EventEmitter();
	@Output() processFileProgress = new EventEmitter();

	@Input()
	set fileTypes(fileType: string) {
		this.pondOptions.acceptedFileTypes = this.fileTypePresets[fileType];
	}

	@Input()
	multipleFiles = false;

	@Input()
	maxFileSize = '30000 KB';

	@Input() set endpoint(s: string) {
		if (!s) return;
		this.pondOptions.server.url = this.data.apiUrl(s);
	}

	@Input()
	set instantUpload(s: boolean) {
		this.pondOptions.instantUpload = s;
	}

	@Input()
	extraClass: string;

	file: any;

	fileTypePresets: { [key: string]: string } = {
		imagesOnly: '*.png, *.jpeg, *.jpg',
		documentsOnly: '*.doc, *.docx, *.odt, *.pdf',
		videoOnly: '*.mov, *.mpg, *.wmv',
		audioOnly: '*.mp3, *.wav, *.mp4'
	};

	pondOptions: any = {
		multiple: this.multipleFiles,
		maxFileSize: this.maxFileSize,
		instantUpload: this.instantUpload,
		name: 'AttachmentFile',
		server: {
			headers: {
				Accept: 'application/json'
			},
			process: {
				headers: {
					Accept: 'application/json'
				},
				withCredentials: true,
				onerror: async (error: any) => {
					try {
						const {status, errors, title} = JSON.parse(error);
						if (status === 401) {
							await this.authService.refreshToken().toPromise();
							const filePondInstance = this.myPond;
							const file = this.file;
							if (file && filePondInstance) {
								const fileInPond = filePondInstance.getFile(file.id);
								if (!fileInPond) {
									await filePondInstance.addFile(file.file);
								}
								await filePondInstance.processFile(file.id);
							}
						} else {
							if (errors && errors?.fileUploadError && status === 422) {
								this.store.dispatch(fromMessaging.sendError({
									message: errors.fileUploadError.map((msg: string) => msg).join(', '),
									title
								}));
							}
						}
					} catch (err) {
						if (err instanceof SyntaxError) return;
						this.store.dispatch(fromMessaging.sendError({
							message: 'Failed to refresh token or retry upload',
							title: err?.title
						}));
					}
				}
			}
		},
		credentials: 'include'
	};

	constructor(
		private data: DataService,
		private authService: AuthService,
		private store: Store
	) {}

	pondHandleInit() {
	}

	pondHandlePrepareFile = (event: any) => this.file = event.file;

	pondHandleProcessFile(event: any) {
		if (event.error !== null) {
			this.fileLoadingError.emit(true);
			this.loading.emit(false);
		} else {
			this.store.dispatch(fromMessaging.sendSuccess({
				message: event.file.file.name,
				title: 'file uploaded'
			}));
			this.done.emit(event.file);
			this.loading.emit(false);
			this.fileLoadingError.emit(false);
		}
	}

	removeFile = () => this.remove.emit();
}
